<template>
  <div>
    <header>
      <v-row class="mx-2 my-1">
        <QuotationBackButton @back="goBack" class="mx-8 my-0" />
        <v-spacer />
        <BaseButton v-html="'IMPRIMIR'" class="secondary" @click="print" />
      </v-row>
    </header>
    <QuotationDocumentAgricola
      v-if="isAgricola"
      :currentQuotation="this.currentQuotation"
      :isTableView="isTableView"
    />

    <QuotationDocumentCafezal
      v-if="isCafezal"
      :currentQuotation="this.currentQuotation"
      :isTableView="isTableView"
      :isGranizo="isGranizo"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import QuotationDocumentAgricola from "../components_agro/QuotationDocumentAgricola.vue";
import QuotationDocumentCafezal from "../components_agro/QuotationDocumentCafezal.vue";
import QuotationBackButton from "../components_agro/QuotationBackButton";

export default {
  name: "PrintQuotationAgro",
  mixins: [QuotationMixin, LoadingRequest],
  components: {
    QuotationDocumentAgricola,
    QuotationDocumentCafezal,
    QuotationBackButton
  },
  data() {
    return {
      isTableView: false,
      isGranizo: true
    };
  },
  created() {
    const id = this.$route.params.id;
    if (this.isResuming) {
      this.resumeQuotation(id);
    }

    this.isTableView = this.$route.params.isTableView;
    this.isGranizo = this.$route.params.isGranizo;
  },
  mounted() {
    window.addEventListener("afterprint", this.closePrintDialog);
  },
  beforeDestroy() {
    window.removeEventListener("afterprint", this.closePrintDialog);
  },
  computed: {
    ...mapState("quotation", ["infoCostQuotation", "currentQuotation"]),
    ...mapState(["nameOptionsDataTable", "filterDataTable"]),
    isResuming() {
      return this.$route.params?.id != null;
    },
    isCafezal() {
      return this.currentQuotation.itens_cafezal?.length > 0;
    },
    isAgricola() {
      return this.currentQuotation.itens_agricola?.length > 0;
    }
  },
  methods: {
    ...mapActions("quotation", ["requestCurrentQuotationAgro"]),
    resumeQuotation(id) {
      if (this.isResuming && id != null) {
        this.withLoading(this.requestCurrentQuotationAgro(id)).then(() => {
          this.currentQuotation, this.print();
        });
      }
    },
    print() {
      window.print();
    },
    closePrintDialog() {
      window.close();
    },
    goBack() {
      window.history.back();
    }
  }
};
</script>

<style lang="sass">
@media print
  body
    -webkit-print-color-adjust: exact
  header
    display: none
</style>
